import type { ComponentChildren, JSX } from "preact";
import { useState } from "preact/hooks";
import { classNames } from "@gss/common/classNames";
import "./Navbar.css";
import { Container } from "./Container";

interface Props {
    className?: string;
    brand?: JSX.Element;
    children?: ComponentChildren;
}

export function Navbar({
    brand,
    className,
    children,
    ...rest
}: Props): JSX.Element {
    const [show, setShow] = useState(false);

    return (
        <nav
            className={classNames(
                "gss-menu navbar navbar-light bg-light navbar-expand-lg",
                className,
            )}
            {...rest}
        >
            <Container fluid>
                {brand}

                <button
                    type="button"
                    className={classNames(
                        "navbar-toggler",
                        !show && "collapsed",
                    )}
                    aria-controls="basic-navbar-nav"
                    aria-expanded={show}
                    onClick={() => setShow(!show)}
                >
                    <span className="navbar-toggler-icon" />
                </button>

                <div
                    id="basic-navbar-nav"
                    className={classNames(
                        "navbar-collapse collapse",
                        show && "show",
                    )}
                >
                    {children}
                </div>
            </Container>
        </nav>
    );
}

interface BrandProps {
    href: string;
    children: ComponentChildren;
}

export function NavbarBrand({ href, children }: BrandProps): JSX.Element {
    return (
        <a className="navbar-brand" href={href}>
            {children}
        </a>
    );
}

interface NavProps {
    className?: string;
    children: ComponentChildren;
}

export function NavbarNav({ className, children }: NavProps): JSX.Element {
    return (
        <div className={classNames("navbar-nav", className)}>{children}</div>
    );
}
